import Vue from 'vue';
import oauthUtils from 'utils/oauthUtils';

export default () => {
  Vue.use((v) => {
    v.prototype.$oauth2 = v.oauth2 = oauthUtils;
  });
};
